import styled from 'styled-components';
import base from '@sizeid/commons/utils/base';
import { media } from '@sizeid/commons/utils/styles';

import ContentWhiteBox from 'components/ContentWhiteBox';

import arrow from '../images/arrow.png';

export default styled(ContentWhiteBox)`
  margin: 40px 0;
  position: relative;

  ${media.moreThan('companyHistoryPlus')`
    text-align: left;
    padding: ${base(2.5)};

    &:before {
      content: '';
      display: block;
      background: url('${arrow}') 0 0 no-repeat;
      background-size: 17px 22px;
      width: 17px;
      height: 22px;
      position: absolute;
      top: 38px;
      left: -16px;
    }
  `};
`;
